import { GithubIssueItem } from '@/pages/MainPlatform/Company/List/typings';
import { getPlatformListToUid } from '@/services/company/CompanyController';
import { getContractList } from '@/services/financial/FinancialController';
import { PlatformEnum } from '@/settings/enum';
import { useModel } from '@@/plugin-model';
import { CopyOutlined } from '@ant-design/icons';
import { ProList } from '@ant-design/pro-components';
import { useRequest } from 'ahooks';
import { Button, Drawer, Input, message, Space, Tag, Typography } from 'antd';
import { log } from 'mathjs';
import React, { cloneElement, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { sessionStorageGet, sessionStorageRemove } from '@/utils/catch';

export default (props: any) => {
  const { children } = props;
  const { getProjectListWithCompanyReq } = useModel('authModel');
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);

  const platform = useSelector((state: any) => state.platform);

  const fetchProjectListToUid = useRequest(getPlatformListToUid, {
    manual: true,
  });

  const getContractListFetch = useRequest(getContractList, {
    manual: true,
  });

  const onClose = () => {
    setOpen(false);
  };

  async function onClick(data: any) {
    // const newWindow = window.open('/', '_blank'); // 打开新页面

    getContractListFetch.runAsync({
      project_id: data.id,
      is_primary: '1',
    }).then((res) => {
      const newWindow = window.open('/', '_blank'); // 打开新页面
      if (newWindow) {
        // 注入脚本到新页面，在新页面中处理数据并删除临时变量
        newWindow.onload = () => {
          newWindow.sessionStorage.setItem('temp_info', JSON.stringify(data)); // 传递临时键名
          newWindow.sessionStorage.setItem('contract', JSON.stringify(res['data'][0])); // 存储合同信息
        };
      }
    });
  }

  function onTitleClick() {
    dispatch({ type: `${PlatformEnum.NAME}/removePlatformProject`, payload: platform[PlatformEnum.COMPANY].id });
    sessionStorageRemove('contract');
    window.location.href = '/';
  }


  // 复制文本到剪贴板
  const copyToClipboard = (text: any) => {
    try {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'absolute';
      textarea.style.opacity = '0';
      textarea.style.pointerEvents = 'none';
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);

      message.success('项目名已复制到剪贴板！');
    } catch (error) {
      console.error('复制失败', error);
      message.error('复制失败，请手动复制！');
    }
  };

  return (
    <React.Suspense fallback={'loading'}>
      {cloneElement(children, { onClick: () => setOpen(true) })}
      <Drawer
        title={
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div>快速进入项目入口</div>
            {platform.platform_type === 3 && <Button onClick={onTitleClick}>返回公司</Button>}
          </div>
        }
        width={550}
        closable={false}
        placement="left"
        onClose={onClose}
        open={open}
      >
        <ProList<GithubIssueItem>
          search={{}}
          rowKey="name"
          request={async (params) => {
            const { current, ...values } = params;
            return await fetchProjectListToUid.runAsync({
              ...values,
              page: current,
              platform_id: 3,
              company_id: platform[PlatformEnum.COMPANY].id,
            });
          }}
          pagination={{
            pageSize: 10,
            size: 'small',
          }}
          showActions="hover"
          form={{
            layout: 'inline', // 使用 'vertical' 布局将 label 放在上方
            labelCol: { span: 0 }, // 自定义 label 的宽度
            size: 'middle',
            className: 'drawer-company-list-search',
          }}
          metas={{
            type: {
              dataIndex: 'select_all',
              title: '',
              render: (_) => {
                return <Space size={0}></Space>;
              },
              renderFormItem: () => {
                return (
                  <Input
                    // 自定义配置
                    placeholder="请输入搜索信息"
                  />
                );
              },
            },
            title: {
              dataIndex: 'current_company_no',
              search: false,
              render: (_) => {
                return (
                  <Space size={0}>
                    <Tag color="blue">{_}</Tag>
                  </Space>
                );
              },
              renderFormItem: () => {
                return (
                  <Input
                    // 自定义配置
                    placeholder="请输入项目名称"
                  />
                );
              },
            },
            subTitle: {
              dataIndex: 'project_name',
              render: (_, row) => {
                return (
                  <Space size={8}>
                    <Typography.Text
                      style={{
                        width: '220px',
                        cursor: 'pointer',
                        color: '#1890ff',
                        textDecoration: 'underline'
                      }}
                      ellipsis={{ tooltip: _ }}
                      onClick={() => onClick(row)}
                    >
                      {_}
                    </Typography.Text>
                    <Button
                      type="text"
                      size="small"
                      icon={<CopyOutlined />}
                      onClick={(e) => {
                        e.stopPropagation();
                        copyToClipboard(_);
                      }}
                      style={{
                        padding: '2px 6px',
                        fontSize: '12px',
                        color: '#1890ff'
                      }}
                    />
                  </Space>
                );
              },
              search: false,
            },
            description: {
              dataIndex: 'project_content',
              search: false,
              render: (text: React.ReactNode, row: any) => {
                return (
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <Typography.Text
                        type={'secondary'}
                        ellipsis={{ tooltip: text }}
                        style={{ display: 'block' }}
                      >
                        {text}
                      </Typography.Text>
                    </div>
                    {row.total_amount && (
                      <Typography.Text type={'secondary'} style={{ fontSize: '12px', whiteSpace: 'nowrap' }}>
                        总额: ¥{row.total_amount}
                      </Typography.Text>
                    )}
                  </div>
                );
              },
            },
            actions: {
              render: (text, row) => [
                <a onClick={() => onClick(row)} target="_blank" rel="noopener noreferrer" key="view">
                  进入项目
                </a>,
              ],
              search: false,
            },
          }}
        />
      </Drawer>
    </React.Suspense>
  );
};
